(() => {
  'use strict';

  const root = document.documentElement;
  root.classList.add('bpc-collection-filter-v2');
  let frame = 0;

  const headerBottom = () => {
    const header = document.querySelector('.section-header');
    if (!header) return 0;
    const rect = header.getBoundingClientRect();
    return Math.max(0, Math.round(rect.bottom > 0 ? rect.bottom : rect.height));
  };

  const railHeight = () => {
    const rail = document.querySelector('[data-bpc-collection-rail-shell]');
    if (!rail || !rail.classList.contains('is-fixed') || rail.classList.contains('is-past-grid')) return 0;
    return Math.max(0, Math.round(rail.getBoundingClientRect().height));
  };

  const nativeSort = () =>
    document.querySelector('#SortBy-mobile') || document.querySelector('#FacetSortDrawerForm #SortBy');

  const syncSort = () => {
    const container = document.querySelector('.facets-container-drawer');
    const native = nativeSort();
    if (!container || !native) return;

    let label = container.querySelector(':scope > .bpc-filter-sort-mobile');
    if (!label) {
      label = document.createElement('label');
      label.className = 'bpc-filter-sort-mobile';
      label.innerHTML = '<span class="visually-hidden">Sort products</span><select aria-label="Sort products"></select>';
      container.appendChild(label);
      label.querySelector('select').addEventListener('change', (event) => {
        const target = nativeSort();
        if (!target) return;
        target.value = event.currentTarget.value;
        target.dispatchEvent(new Event('input', { bubbles: true }));
        target.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    const select = label.querySelector('select');
    const signature = [...native.options].map((option) => `${option.value}|${option.textContent}`).join('~');
    if (select.dataset.signature !== signature) {
      select.replaceChildren(...[...native.options].map((option) => option.cloneNode(true)));
      select.dataset.signature = signature;
    }
    select.value = native.value;
  };

  const syncResultButtons = () => {
    const source = document.querySelector('#ProductCount, #ProductCountDesktop, .mobile-facets__count');
    const match = (source?.textContent || '').replace(/\s+/g, ' ').trim().match(/[\d.,]+/);
    let label = 'View products';
    if (match) {
      const value = match[0];
      label = Number(value.replace(/,/g, '')) === 1 ? 'View 1 product' : `View ${value} products`;
    }
    document.querySelectorAll('.mobile-facets__footer .button--primary, .mobile-facets__footer .apply-button').forEach((button) => {
      if (button.textContent.trim() !== label) button.textContent = label;
    });
  };

  const update = () => {
    frame = 0;
    document.querySelectorAll('.mobile-facets__sort').forEach((sort) => {
      sort.closest('.mobile-facets__details')?.classList.add('bpc-filter-native-sort');
    });
    root.classList.toggle('bpc-filter-open', Boolean(document.querySelector('.mobile-facets__disclosure[open]')));

    const filters = document.getElementById('main-collection-filters');
    if (filters) {
      const top = headerBottom() + railHeight();
      root.style.setProperty('--bpc-filter-top', `${top}px`);
      filters.classList.toggle('is-bpc-stuck', filters.getBoundingClientRect().top <= top + 1 && scrollY > 20);
    }

    syncSort();
    syncResultButtons();
  };

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };

  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  addEventListener('orientationchange', schedule, { passive: true });
  document.addEventListener('change', schedule);

  new MutationObserver(schedule).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'open']
  });

  document.addEventListener('click', (event) => {
    const summary = event.target.closest?.('.mobile-facets__details > summary');
    if (summary && innerWidth >= 990) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const details = summary.parentElement;
      const open = !details.open;
      details.closest('.mobile-facets__main')?.querySelectorAll('.mobile-facets__details[open]').forEach((other) => {
        if (other === details) return;
        other.open = false;
        other.classList.remove('menu-opening');
        other.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      });
      details.open = open;
      details.classList.toggle('menu-opening', open);
      summary.setAttribute('aria-expanded', String(open));
      details.closest('.mobile-facets__main')?.classList.remove('submenu-open');
      schedule();
      return;
    }

    const backdrop = event.target.closest?.('.mobile-facets');
    if (backdrop && event.target === backdrop) {
      backdrop.closest('menu-drawer')?.querySelector('.mobile-facets__close')?.click();
    }
  }, { capture: true });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const disclosure = document.querySelector('.mobile-facets__disclosure[open]');
    if (!disclosure) return;
    const submenu = [...disclosure.querySelectorAll('.mobile-facets__details[open]')]
      .find((details) => details.tagName === 'DETAILS');
    if (innerWidth < 990 && submenu) submenu.querySelector('.mobile-facets__close-button')?.click();
    else disclosure.querySelector('.mobile-facets__close')?.click();
    event.stopImmediatePropagation();
  }, { capture: true });

  update();
})();

;(() => {
  'use strict';

  const root = document.documentElement;
  let closing = false;

  const syncSiteMenu = () => {
    const open = Boolean(document.querySelector('.section-header details[open]'));
    root.classList.toggle('bpc-site-menu-open', open);

    const filters = document.getElementById('main-collection-filters');
    const fixedRail = document.querySelector('.bpc-collection-v4__rail-shell.is-fixed');

    [filters, fixedRail].forEach((element) => {
      if (!element) return;
      element.toggleAttribute('inert', open);
      if (open) element.setAttribute('aria-hidden', 'true');
      else element.removeAttribute('aria-hidden');
    });

    if (!open) {
      closing = false;
      return;
    }

    root.classList.remove('bpc-filter-open');
    const disclosure = document.querySelector('.mobile-facets__disclosure[open]');
    if (!disclosure || closing) return;

    closing = true;
    const closeButton = disclosure.querySelector('.mobile-facets__close');
    if (closeButton) closeButton.click();
    else disclosure.removeAttribute('open');

    requestAnimationFrame(() => {
      closing = false;
      syncSiteMenu();
    });
  };

  new MutationObserver(syncSiteMenu).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'open']
  });

  document.addEventListener('shopify:section:load', syncSiteMenu);
  addEventListener('pageshow', syncSiteMenu);
  syncSiteMenu();
})();
